import { render, staticRenderFns } from "./AddBlog.vue?vue&type=template&id=f25fee36&scoped=true&"
import script from "./AddBlog.vue?vue&type=script&lang=js&"
export * from "./AddBlog.vue?vue&type=script&lang=js&"
import style0 from "./AddBlog.vue?vue&type=style&index=0&id=f25fee36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25fee36",
  null
  
)

export default component.exports